<div
  [class.collapsed]="collapsed"
  (click)="collapsed = false"
>
  <b>FAQs:</b>
  <ol>
    <li><b>How to stake RUBY to get Sweepstake entries and brand new NFTs?</b></li>
    <ol>
      <li>Use Metamask or a Wallet Connect compatible wallet (like Trust Wallet) with Rubies to stake on <a
          href="https://rubyplaynetwork.xportal.app/nft-staking"
        >https://rubyplaynetwork.xportal.app/nft-staking</a></li>
    </ol>

    <li><b>What NFTs will I get and how many Sweepstake entries are they worth?</b></li>
    <ol>
      <li>Stake Rubies to obtain special NFTs and obtain Sweepstake entries depending on the amount you stake. You will
        receive at least one entry to our monthly Sweepstake for every 1,000 Rubies you successfully stake (bonus
        entries
        will be assigned for amounts over 10,000) and entries will be kept as long as the NFTs are in your wallet at the
        time of the Monthly snapshot.</li>
      <li>Staking NFTs and entries into Monthly Sweepstakes:</li>
      <ol>
        <li>You will be assigned basic ORANGE NFT and 1 ticket per 1,000 Ruby staked, plus bonus tickets for higher
          levels:</li>
        <ol>
          <li>BLUE NFT: 10,001 - 50,000 Ruby staked = 5 bonus tickets</li>
          <li>GREEN NFT: 50,001 - 250,000 Ruby staked = 15 bonus tickets</li>
          <li>RED NFT: 250,001 - 1 Million Ruby staked = 40 bonus tickets</li>
          <li>GOLD NFT: Over 1 Million Ruby staked = 100 bonus tickets</li>
        </ol>
      </ol>
    </ol>

    <li><b>What happens to the old staking program?</b></li>
    <ol>
      <li>The current (now old) staking program will still continue and you will still be able to earn and claim rewards
        (but not make any new stakes) until it expires.</li>
    </ol>

    <li><b>Do I get to keep the NFTs?</b></li>
    <ol>
      <li>The NFTs gained from the staking will belong to you as long as the staking is active. Once you unstake you
        will
        lose them, but stake Ruby again and you can obtain different NFTs depending on the amount you stake - see the
        chart. You will only get benefits and be eligible for the Monthly Sweepstake draw while you own the NFTs.</li>
    </ol>

    <li><b>How does the Sweepstake draw work?</b></li>
    <ol>
      <li>First announcement will be made on Friday October the 14th, to participate make sure you have staked your
        Rubies
        by the end of October the 7th UTC time. Snapshot for the 1st Sweepstake will be taken sometime after October the
        7th and before October the 14th.</li>
      <li>Every subsequent Sweepstake will take place with a snapshot being taken on a random day in the previous month
        and a draw taking place on every 2nd Friday of the month.
        For example, the November draw will take place on November the 11th, and the snapshot will take place between
        October the 14th and October the 31st.
        The December draw will take place on December the 9th, and the snapshot will take place between November the 1st
        and the 31st.</li>
    </ol>

    <li><b>How will I know if I won?</b></li>
    <ol>
      <li>All the winning wallets will be announced and Rubies will be sent to corresponding addresses, you do not have
        to
        do anything.</li>
    </ol>

    <li><b>Who can participate?</b></li>
    <ol>
      <li>Anyone who has 1,000 Rubies or more and can stake them. They will receive a NFT with Sweepstake tickets for
        every 1,000 Rubies they successfully stake (bonus entries will be assigned for amounts over 10,000) and entries
        will be recorded once per Month at the time of the snapshot before the draw on the following Month (usually on
        the
        2nd Friday of the month).</li>
    </ol>

    <li><b>Where do I go for help or more information?</b></li>
    <ol>
      <li>For more information or help reach out in either our Telegram or Discord channel.</li>
    </ol>
  </ol>

  <b>Terms and Conditions</b>
  <ol type="A">
    <li>General</li>
    <ol>
      <li>This promotion (Promotion) is managed by Ruby Play Net Limited (RPN), a company registered in New Zealand. All
        giveaways under this promotion are at RPN’s discretion. RPN may cancel participation in the promotion at any
        time.</li>
      <li>Under this Promotion, RPN grants certain individuals Non-Fungible Tokens (NFTs) and the chance to win RUBY
        tokens (RUBY) according to the terms of this Promotion. If an individual stakes RUBY on <a
          href="https://rubyplaynetwork.xportal.app/nft-staking"
        >https://rubyplaynetwork.xportal.app/nft-staking</a>, RPN will allocate that individual an NFT of a certain type
        and entries into a Sweepstake depending on the amount of RUBY staked.</li>
      <li>Ruby Play Network Promotional T&Cs apply: <a
          href="https://www.rubyplaynetwork.com/help-and-legal/ruby-token-promotional-terms-and-conditions"
        >https://www.rubyplaynetwork.com/help-and-legal/ruby-token-promotional-terms-and-conditions</a></li>
    </ol>

    <li>Allocation</li>
    <ol>
      <li>Stake Rubies to obtain special NFTs and obtain Sweepstake entries depending on the amount you stake. You will
        receive one entry to our monthly Sweepstake for every 1,000 Rubies you successfully stake (bonus entries will be
        assigned for amounts over 10,000) as follows:</li>
      <ol>
        <li>You will be assigned a basic ORANGE NFT and 1 ticket per 1,000 Ruby staked, plus bonus tickets for higher
          levels.</li>
        <li>BLUE NFT: 10,001 - 50,000 Ruby staked = 5 bonus tickets</li>
        <li>GREEN NFT: 50,001 - 250,000 Ruby staked = 15 bonus tickets</li>
        <li>RED NFT: 250,001 - 1 Million Ruby staked = 40 bonus tickets</li>
        <li>GOLD NFT: Over 1 Million Ruby staked = 100 bonus tickets</li>
      </ol>

      <li>Your entries will qualify as long as the NFTs are in your wallet at the time of the Monthly snapshot.</li>
      <li>Employees of RPN may not participate in this promotion.</li>
    </ol>

    <li>Draw</li>
    <ol>
      <li>Entries to this sweepstakes competition are calculated based on the number of tickets held at the time of the
        snapshot taken randomly during each month. The date of the snapshot will be announced on the first Tuesday of
        the following month and the Draw will take place on the 2nd Friday of the following month. We will draw 3 random
        tickets out of the pool of tickets and the wallet address belonging to these will be awarded 100,000 RUBY each.
        There will be only one prize allocation per each address per month - only max 1 prize per same address per
        month, in case of 2nd allocation we will re-draw the prize again.</li>
    </ol>
  </ol>
</div>
